import SortImagesActivity from '../SortImagesActivity/SortImagesActivity';

export default function RealTimeActivity({
  activity,
  activityConf,
  taskProgressActions,
  demoMode,
  forceRestart,
}) {
  const TypeGameActivity = {
    sortImages: SortImagesActivity,
  }[activity.data.subType];

  return (
    <TypeGameActivity
      activity={activity}
      activityConf={activityConf}
      taskProgressActions={taskProgressActions}
      demoMode={demoMode}
      forceRestart={forceRestart}
    />
  );
}
